import appConstants from '../constants';
import capitalizeWords from './capitalizeWords';

export default function convertQualIconsArrayToRolesAndLevelsObject(qualIconsArray) {
  let rolesAndLevels = {
    [appConstants.KEY_ROLES_AND_LEVELS]: {
      [appConstants.KEY_INTEGRATOR]: capitalizeWords(qualIconsArray.filter(qual => Object.keys(qual)[0] === appConstants.KEY_CERTIFICATION)[0][appConstants.KEY_CERTIFICATION]),
      [appConstants.KEY_PROVIDER]: capitalizeWords(qualIconsArray.filter(qual => Object.keys(qual)[0] === appConstants.KEY_PROVIDER_LOWERCASE)[0][appConstants.KEY_PROVIDER_LOWERCASE]),
      [appConstants.KEY_DEVELOPER]: capitalizeWords(qualIconsArray.filter(qual => Object.keys(qual)[0] === appConstants.KEY_DEVELOPER.toLowerCase())[0]?.[appConstants.KEY_DEVELOPER.toLowerCase()]),
      [appConstants.KEY_ADVISOR]: capitalizeWords(qualIconsArray.filter(qual => Object.keys(qual)[0] === appConstants.KEY_ADVISOR.toLowerCase())[0]?.[appConstants.KEY_ADVISOR.toLowerCase()])
    }
  };
  if(!rolesAndLevels[appConstants.KEY_ROLES_AND_LEVELS][appConstants.KEY_INTEGRATOR]) {
    delete rolesAndLevels[appConstants.KEY_ROLES_AND_LEVELS][appConstants.KEY_INTEGRATOR];
  }
  if(!rolesAndLevels[appConstants.KEY_ROLES_AND_LEVELS][appConstants.KEY_PROVIDER]) {
    delete rolesAndLevels[appConstants.KEY_ROLES_AND_LEVELS][appConstants.KEY_PROVIDER];
  }
  if(!rolesAndLevels[appConstants.KEY_ROLES_AND_LEVELS][appConstants.KEY_DEVELOPER]) {
    delete rolesAndLevels[appConstants.KEY_ROLES_AND_LEVELS][appConstants.KEY_DEVELOPER];
  }
  if(!rolesAndLevels[appConstants.KEY_ROLES_AND_LEVELS][appConstants.KEY_ADVISOR]) {
    delete rolesAndLevels[appConstants.KEY_ROLES_AND_LEVELS][appConstants.KEY_ADVISOR];
  }
  return rolesAndLevels;
}
